import { routeById } from '@/config/routeManifest'

export function getTabTooltip(routeId: string): string | undefined {
  return routeById(routeId)?.tooltip
}
